import { createContext, useEffect, useMemo, useState } from "react";

export const CustomThemeContext = createContext({});

export const themes = {
  berelian: {
    name: "berelian",
    persianName: "برلیان",

    colors: {
      primary: "#006472",
      secondary: "#00B2C9",
      accent: "#00D5EE",

      background: "#F2FBFC",
      surface: "#DDF4F7",
      surfaceAlt: "#FFFFFF",

      text: {
        primary: "#1F2937",
        secondary: "#4B5563",
        muted: "#6B7280",
        inverse: "#FFFFFF",
      },

      border: "#B7DDE2",
      disabledBackground: "#F3F4F6",
      disabledText: "#9CA3AF",

      success: "#16A34A",
      warning: "#F59E0B",
      error: "#DC2626",
      info: "#0284C7",
    },
  },

  toranj: {
    name: "toranj",
    persianName: "ترنج",

    colors: {
      primary: "#2F9E41",
      secondary: "#1F2937",
      accent: "#84CC16",

      background: "#F7F8F9",
      surface: "#FFFFFF",

      text: {
        primary: "#111827",
        secondary: "#4B5563",
        muted: "#6B7280",
        inverse: "#FFFFFF",
      },

      border: "#E5E7EB",
      disabledBackground: "#F3F4F6",
      disabledText: "#9CA3AF",

      success: "#16A34A",
      warning: "#F59E0B",
      error: "#DC2626",
      info: "#2563EB",
    },
  },
};

const CustomThemeContextProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchCompanyName = async () => {
    try {
      const res = await new Promise((resolve) => {
        setTimeout(() => {
          resolve("برلیان");
        }, 70);
      });

      setCompanyName(res);
    } catch (error) {
      console.log("error in fetchCompanyName in CustomThemeContext", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, []);

  const currentTheme = useMemo(() => {
    switch (companyName) {
      case "برلیان":
        return themes.berelian;

      case "ترنج":
        return themes.toranj;

      default:
        return themes.toranj;
    }
  }, [companyName]);

  if (loading) {
    return (
      <div className="initial-loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <CustomThemeContext.Provider
      value={{
        CName: companyName,
        CPersianName: currentTheme.persianName,
        currentTheme: currentTheme,
      }}
    >
      {children}
    </CustomThemeContext.Provider>
  );
};

export default CustomThemeContextProvider;
